// src/features/seleccionTaller/Infrastructura/store/tallerSagas.ts
import { call, put, select, takeLatest } from 'redux-saga/effects'
import {
  buscarTalleresFailure,
  buscarTalleresStart,
  buscarTalleresSuccess,
  geolocalizarStart,
} from './tallerSlice'
import { filterTiendas, searchByPostCode } from '../../../../../../common/logic'
import { CestaState } from '../../../../../../common/context/reducers/cestaReducer'
import {
  getSpecialServices,
  selectCesta,
} from '../../../../../../common/context/selectors/cestaSelectors'
import tallerSyncSagas from './tallerSyncSagas'

// Tipus de producte de la cesta (neumatico|revision|itv_ap...). Sempre inclou
// 'neumatico', ja que el buscador de neumàtics hi afegirà pneumàtics encara que
// la cesta encara no en tingui.
function* getCestaSpecialServices() {
  const cestaState: CestaState = yield select(selectCesta)
  const services = getSpecialServices(cestaState).split('|').filter(Boolean)
  if (!services.includes('neumatico')) services.unshift('neumatico')
  return services.join('|')
}

// Worker Saga: buscar talleres por código postal o localidad
function* buscarTalleresWorker(action: ReturnType<typeof buscarTalleresStart>) {
  try {
    const query = action.payload.trim()

    const specialServices: string = yield call(getCestaSpecialServices)

    const result = yield call(
      searchByPostCode,
      query,
      true,
      undefined,
      undefined,
      specialServices
    )

    yield put(buscarTalleresSuccess(result.tiendas))
  } catch (error: any) {
    yield put(buscarTalleresFailure(error.message))
  }
}

// Worker Saga: geolocalizar usuario y buscar talleres cercanos
function* geolocalizarWorker() {
  try {
    const position: GeolocationPosition = yield call(() => {
      return new Promise<GeolocationPosition>((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject)
      })
    })

    const lat = position.coords.latitude
    const lon = position.coords.longitude

    const specialServices: string = yield call(getCestaSpecialServices)

    const talleres = yield call(
      filterTiendas,
      '',
      lat,
      lon,
      undefined,
      specialServices
    )

    yield put(buscarTalleresSuccess(talleres))
  } catch (error: any) {
    yield put(buscarTalleresFailure(error.message))
  }
}

// Watcher Saga
export default function* tallerSagas() {
  yield takeLatest(buscarTalleresStart.type, buscarTalleresWorker)
  yield takeLatest(geolocalizarStart.type, geolocalizarWorker)
  // seleccionarTaller al catàleg: tallerSyncSagas actualitza cesta/cita si hi ha pneumàtics de cotxe.
  yield tallerSyncSagas()
}
